// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__PTX9Y","footer":"ModalUpdate_footer__3TvAZ"};